import { useInView } from "react-intersection-observer";
import classNames from "classnames";
import { useMediaQuery } from "react-responsive";

const EnterViewportAnimation = ({
  children,
  mode = "fade-in",
  onEnter = undefined
}) => {
  const isPrint = useMediaQuery({ query: "print" });

  const [ref, inView] = useInView({
    amount: "some",
    triggerOnce: true
  });
  if (inView && typeof onEnter === "function") {
    onEnter();
  }
  return (
    <div ref={ref}>
      <div className={classNames({ ["will-" + mode]: !isPrint, show: inView })}>
        {children}
      </div>
    </div>
  );
};

export default EnterViewportAnimation;
